module.exports = __webpack_public_path__ + "static/media/edit_comment_notify.0c96dfe3.svg";